import { render, staticRenderFns } from "./phoneLogin.vue?vue&type=template&id=7d36718e&scoped=true"
import script from "./phoneLogin.vue?vue&type=script&lang=js"
export * from "./phoneLogin.vue?vue&type=script&lang=js"
import style0 from "./phoneLogin.vue?vue&type=style&index=0&id=7d36718e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d36718e",
  null
  
)

export default component.exports